export default function Badge(text, variant = "blue") {
  // 🎨 Color palette
  const brand = {
    blue: "#0B5ED7",
    red: "#E11D48",
    green: "#16A34A",
    indigo: "#4F46E5",
    gray: "#6B7280",
  };

  const color = brand[variant] || brand.blue;

  // Generate a light background from the color (soft pastel)
  const lightBg = `${color}20`; // adds transparency to create soft tint

  return (
    <span
      className="rounded-full px-3 py-1 text-[11px] sm:text-xs font-semibold"
      style={{
        color,
        backgroundColor: lightBg,
        border: `1px solid ${color}`,
      }}
    >
      {text}
    </span>
  );
}

